const { getElements, formatMoney } = window.BAO.Utils

class LoyaltyRewardsList extends window.BAO.CustomElement() {
  static get requiredEls () {
    return ['list', 'claimedList']
  }

  setupListeners () {
    super.setupListeners()

    if (
      this.els.list?.element.firstChild &&
      this.els.claimedList?.element.firstChild
    ) {
      this.handleMessage()
    } else {
      this.observer = new MutationObserver(() => {
        this.handleMessage()
      })

      this.observer.observe(this, {
        childList: true,
        subtree: true,
      })
    }

    this.rewardPointsEls.forEach(el => {
      const observer = new MutationObserver(() => {
        this.handlePointsMessage(el)
      })

      observer.observe(el, {
        childList: true,
        subtree: true,
      })
    })
  }

  handlePointsMessage (el) {
    const points = el.textContent
    const pointsApproved = el.closest('[data-customer-points]').dataset
      .customerPoints
    const pointsCombined = parseInt(points) + parseInt(pointsApproved)
    const pointsDifference = 1000 - (pointsCombined % 1000)

    this.rewardPointsDifferenceEls.forEach(el2 => {
      if (pointsDifference !== el2.textContent) {
        el2.textContent = pointsDifference
      }
    })
  }

  handleMessage () {
    const highestClaimedRewardValue = this.getRewardValue(
      this.claimedRewardItemEls,
      'claimed',
      'highest',
    )
    const nextAvailableRewardValue = this.getRewardValue(
      this.availableRewardButtonEls,
      'button',
      'highest',
    )
    const nextRewardValue = this.getRewardValue(
      this.rewardButtonEls,
      'button',
      'next',
    )

    if (highestClaimedRewardValue > 0) {
      this.renderMessage('redeem-reward', highestClaimedRewardValue)
    } else if (nextAvailableRewardValue > 0) {
      this.renderMessage('collect-reward', nextAvailableRewardValue)
    } else if (nextRewardValue > 0) {
      this.renderMessage('no-reward', nextRewardValue)
    }

    if (this.getHighestClaimedRewardItemValue() > 0) {
      this.renderMessage(
        'redeem-reward',
        this.getHighestClaimedRewardItemValue(),
      )
    } else if (this.getHighestRewardButtonValue() > 0) {
      this.renderMessage('collect-reward', this.getHighestRewardButtonValue())
    } else if (this.getLowestRewardButtonValue() > 0) {
      this.renderMessage('no-reward', this.getLowestRewardButtonValue())
    }
  }

  getRewardValue (items, el, type) {
    if (!items || items.length < 1) return

    let reward = 0
    let text = ''

    items.forEach(item => {
      if (el === 'claimed') {
        text = item.querySelector('.lion-claimed-reward-item__title')
          ?.textContent
      } else if (el === 'button') {
        text = item.parentNode.parentNode.querySelector(
          '.lion-reward-item__title',
        )?.textContent
      }

      if (text.match(/\d+/)) {
        const value = parseInt(`${text.match(/\d+/)[0]}00`)

        if (type === 'highest') {
          if (value > reward) {
            reward = value
          }
        } else if (type === 'next') {
          if (value > reward && value < this.currentPoints + 1000) {
            reward = value
          }
        }
      }
    })

    return reward
  }

  renderMessage (messageHtml, value) {
    this.rewardMessageEls.forEach(el => {
      el.querySelectorAll(`[data-message]`).forEach(item => {
        item.style.display = 'none'

        if (item.dataset.message === messageHtml) {
          item.style.display = 'inline'
        }
      })
    })

    this.rewardValueEls.forEach(el => {
      el.innerHTML = formatMoney(value)
    })
  }

  getHighestClaimedRewardItemValue () {
    const items = this.claimedRewardItemEls
    let highestAvailableReward = 0

    if (!items) return

    items.forEach(item => {
      const returnedValue = this.getClaimedRewardItemValue(item)

      const value = parseInt(`${returnedValue}00`)
      if (value > highestAvailableReward) {
        highestAvailableReward = value
      }
    })

    return highestAvailableReward
  }

  getHighestRewardButtonValue () {
    const items = this.availableRewardButtonEls
    let highestAvailableReward = 0

    if (!items) return

    items.forEach(item => {
      const returnedValue = this.getRewardButtonValue(item)
      const value = parseInt(`${returnedValue}00`)
      if (value > highestAvailableReward) {
        highestAvailableReward = value
      }
    })

    return highestAvailableReward
  }

  getLowestRewardButtonValue () {
    const items = this.rewardButtonEls

    if (!items.length) return

    const returnedValue = this.getRewardButtonValue(items[0])
    const value = parseInt(`${returnedValue}00`)

    return value
  }

  getClaimedRewardItemValue (item) {
    const text = item.querySelector('.lion-claimed-reward-item__title')
      ?.textContent
    if (!text) return 0
    if (text.match(/\d+/) == null) return 0
    const monetaryValueFromString = parseInt(text.match(/\d+/)[0])
    return monetaryValueFromString
  }

  getRewardButtonValue (item) {
    const text = item.parentNode.parentNode.querySelector(
      '.lion-reward-item__title',
    )?.textContent
    if (!text) return 0
    if (text.match(/\d+/) == null) return 0
    const monetaryValueFromString = parseInt(text.match(/\d+/)[0])
    return monetaryValueFromString
  }

  get claimedRewardItemEls () {
    return getElements('.lion-claimed-reward-item', {
      context: this.claimedList,
    })
  }

  get rewardButtonEls () {
    return getElements('.lion-reward-item__actions .lion-action-button', {
      context: this.list,
    })
  }

  get availableRewardButtonEls () {
    return this.rewardButtonEls.filter(button =>
      button.querySelector(
        '[data-i18n-key="ui.dashboard.redeem_points.get_reward"]',
      ),
    )
  }

  get rewardMessageEls () {
    return document.querySelectorAll('[data-loyaltylion-points-message]')
  }

  get rewardPointsEls () {
    return document.querySelectorAll('[data-lion-points-for-product-id]')
  }

  get rewardPointsDifferenceEls () {
    return document.querySelectorAll('[data-loyaltylion-points-difference]')
  }

  get rewardValueEls () {
    return document.querySelectorAll('[data-loyaltylion-next-reward]')
  }

  get currentPoints () {
    return parseInt(
      document.querySelector('[data-customer-points]')?.dataset?.customerPoints,
    )
  }
}

if (!customElements.get('loyalty-rewards-list')) {
  customElements.define('loyalty-rewards-list', LoyaltyRewardsList)
}
